import styled from "styled-components";

export const MMarketFavouriteSection = styled.div`
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-right: 10px;
`;
